import { Chip } from "@mui/material";
import React, {useMemo,memo} from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const HumidityKPI = memo(({ avgHum, maxHum, minHum }) => {

   // Good: 3, Moderate: 2 and Poor: 1

   const percentage = useMemo(()=>{
  
    if (avgHum < 20 || avgHum >60) return 0.2;
    if (avgHum >= 20 && avgHum < 30) return 0.5;
    if (avgHum >= 30 && avgHum <= 60) return 0.8;
    
    return 0.2; 

  },[avgHum])


  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        nrOfLevels={3}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgHum}%</span>
      <p className="card-value">Humidity</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max" sx={chipStyle} />
          <p className="m-1 p-0">{maxHum}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle} />
          <p className="m-1 p-0">{minHum}</p>
        </div>
      </div>
    </>
  );
});

export default HumidityKPI;
